<template>
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="16" height="16" class="icon-question" @mouseover="$emit('mouseover')">
    <use class="svg-colorized-el" transform="translate(7.2 11.2)" xlink:href="#icon-question0_fill"/>
    <use class="svg-colorized-el" xlink:href="#icon-question1_fill"/>
    <use class="svg-colorized-el" transform="translate(4.8 3.19)" xlink:href="#icon-question2_fill"/>
    <defs>
      <path id="icon-question0_fill" d="M1.6 0H0v1.6h1.6V0z"/>
      <path id="icon-question1_fill" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zm0 14.552A6.552 6.552 0 1 1 8 1.448 6.56 6.56 0 0 1 14.552 8 6.552 6.552 0 0 1 8 14.552z"/>
      <path id="icon-question2_fill" d="M6.312 2.456A3.2 3.2 0 0 0 0 3.216h1.6a1.606 1.606 0 0 1 3.2.272 1.664 1.664 0 0 1-1.688 1.328.712.712 0 0 0-.712.712v1.688H4v-.912a3.2 3.2 0 0 0 2.312-3.848z"/>
    </defs>
  </svg>
</template>

<script>
export default {
  props: {
  },
};
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/icons/IconQuestion.vue